import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  MemberRelationInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/Info",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  MemberRelationPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/MemberRelation/Post",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetSumReserveIntegral({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumReserveIntegral",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetSumCommission({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumCommission",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationHelpCommissionSearch({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationHelpCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberLevelRelationSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberLevelRelationSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationCommissionSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationCommissionSearch2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationCommissionSearch2",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationCommissionSearch3({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationCommissionSearch3",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationLinkCommissionSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationLinkCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetSumCommission2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumCommission2",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationLinkCommissionSearch2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationLinkCommissionSearch2",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetBossCommissionSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetBossCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetBossSumCommission({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetBossSumCommission",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetSumHelpPrice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumHelpPrice",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
    GetSumOrderIntegral({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumOrderIntegral",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },


};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/memberRelation.js